import React from 'react';

export default () => (
  <svg
    viewBox="0 0 30 30"
    width="30px"
    height="30px"
    xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      fill="currentColor"
      d="M30.018 28.667H0V0h30.018v28.667"
    />
    <path
      d="M15.372 4.377c.452.213.358.489.219 1.793-.142 1.345-.618 3.802-1.535 6.219-.918 2.413-2.28 4.784-3.467 6.539-1.186 1.756-2.201 2.897-2.975 3.556-.777.659-1.314.835-1.665.893-.348.058-.506 0-.6-.177-.094-.176-.127-.466-.046-.82.079-.35.268-.76.804-1.285.541-.527 1.426-1.172 2.661-1.771 1.235-.6 2.817-1.156 4.116-1.537a30.03 30.03 0 013.197-.746 23.98 23.98 0 012.391-.337 14.241 14.241 0 012.186 0c.712.06 1.408.175 2.011.323.6.146 1.108.321 1.551.601.442.276.823.657 1.012 1.083.192.423.192.893.033 1.228-.158.337-.476.541-.839.66a2.103 2.103 0 01-1.267 0c-.49-.148-1.062-.47-1.662-.894-.601-.425-1.235-.952-2.057-1.771a35.417 35.417 0 01-2.692-3.013c-.854-1.083-1.553-2.136-2.028-3.029a11.317 11.317 0 01-.933-2.355c-.206-.733-.364-1.464-.427-2.122s-.034-1.245.03-1.714c.063-.466.16-.82.317-1.055.158-.23.381-.35.539-.408s.254-.058.348-.073c.094-.015.188-.044.333 0 .138.042.321.154.504.268"
      fill="none"
      stroke="#FFF"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.4"
    />
  </svg>
);
